import { defineComponent as _defineComponent } from 'vue'
import { v4 } from 'uuid';
import { computed, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CRadio',
  props: {
    id: null,
    label: null,
    value: null,
    bordered: { type: Boolean },
    inputValue: null,
    error: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: unknown): void;
    (event: 'change', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id?: string;
    label?: string;
    value?: unknown;
    bordered?: boolean;
    inputValue?: unknown;
    error?: boolean;
    disabled?: boolean;
};





const slots = useSlots();

const id = v4();
const inputId = computed(() => props.id || id);

const _model = computed({
    get: () => props.value,
    set: (value: unknown) => emit('input', value)
});

const isChecked = computed(() => _model.value === props.inputValue);

return { __sfc: true,props, emit, slots, id, inputId, _model, isChecked }
}

})